export const divisionFieldMapping = [
  "division_id",
  "code",
  "name",
  "principal_code",
  "principal_id",
  "principal_name",
];
